// Single source of truth for lightning value↔label mappings and the
// type-synthesis SQL fragment. Imported by:
//   - lightningConfig.ts (frontend transformers — grid display)
//   - exportService.ts   (backend SQL CASE — CSV export)
//   - lightningRouter.ts (backend SQL CASE — view query)

export const STRIKE_CHARGE_LABELS: Record<string, string> = {
  P: 'Positive',
  N: 'Negative',
};

export const CLOUD_INDICATOR_LABELS: Record<number, string> = {
  1: 'Cloud-to-Cloud',
  0: 'Cloud-to-Ground',
};

// SQL fragment: identifies the synthetic "test" strike (fixed location + peak current).
// Same expression used by view query (lightningRouter) and CSV export (exportService).
export const TYPE_SYNTHESIS_SQL =
  `(CASE WHEN lat = 61.5004 AND lon = -114.5009 AND peak_current = -14 THEN 'test' ELSE 'strike' END)`;

// Build a SQL CASE expression from a value→label dictionary, around a column name.
// e.g. caseSqlFromMap('strike_charge', STRIKE_CHARGE_LABELS) →
//   "(CASE strike_charge WHEN 'P' THEN 'Positive' WHEN 'N' THEN 'Negative' ELSE strike_charge END)"
export function caseSqlFromMap(column: string, map: Record<string | number, string>, fallback: string = column): string {
  const branches = Object.entries(map)
    .map(([k, v]) => `WHEN ${typeof k === 'string' && isNaN(Number(k)) ? `'${k}'` : k} THEN '${v}'`)
    .join(' ');
  return `(CASE ${column} ${branches} ELSE ${fallback} END)`;
}
